import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { CampaignDetail, CampaignsOverview, DealerCampaignDetail, Footnote } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'campaign',
    events: {
        'Load Campaign Overview': emptyProps(),
        'Load Campaign Overview Success': props<{ campaignsOverview: CampaignsOverview }>(),
        'Load Campaign Overview Failure': props<{ error: string }>(),

        'Load Campaign Detail': props<{ slug: string; utmTerm?: string }>(),
        'Load Campaign Detail Success': props<{ campaign: CampaignDetail }>(),
        'Load Campaign Detail Failure': props<{ error: string }>(),

        'Load Dealer Campaign Detail': props<{ campaignSlug: string }>(),
        'Load Dealer Campaign Detail Success': props<{ campaign: DealerCampaignDetail; footnotes: Footnote[] }>(),
        'Load Dealer Campaign Detail Failure': props<{ error: string }>(),
    },
});
